import type { DocumentData, DocumentSnapshot, QuerySnapshot } from 'firebase/firestore';
import { parseDoc, userSchema, type User } from '../../shared/schemas';

/** Turn a users query snapshot into validated users, dropping unparseable ones. */
export function usersFromSnapshot(
  snapshot: QuerySnapshot<DocumentData>,
  context: string,
): User[] {
  return snapshot.docs
    .map((doc) => parseDoc(userSchema, doc.id, doc.data(), context))
    .filter((user): user is User => user !== null);
}

/** Parse a single user document, or null if it does not exist or is malformed. */
export function userFromDoc(
  snapshot: DocumentSnapshot<DocumentData>,
  context: string,
): User | null {
  if (!snapshot.exists()) return null;
  return parseDoc(userSchema, snapshot.id, snapshot.data(), context);
}

/**
 * Firestore's `in` operator accepts at most 30 values, so friend lists longer
 * than this cannot be fetched in a single query.
 *
 * The friend feed and friend list both silently break past this limit today —
 * see CLAUDE.md, gotcha 6. Batching the queries is the fix.
 */
export const FIRESTORE_IN_LIMIT = 30;
